import React from 'react';
import { ExceptionQueueTable } from '../components/ExceptionQueueTable';
import { useAuth } from '../contexts/AuthContext';
import { useAppShell } from '../contexts/AppShellContext';

// Same statuses as the Exceptions queue — this page only ever shows exception
// rows that were handed off, so its Status column can't show anything else.
const EXCEPTION_STATUSES = ['No Job Found', 'Received Short', 'On Hold'];

export function EscalationsPage() {
  const { user } = useAuth();
  const { demoTeam } = useAppShell();
  // demoTeam overrides the effective team_id, same as pageVisible() in
  // utils/rbac.ts, so the "viewing as" toggle scopes this queue too.
  const effectiveTeam = demoTeam ?? user?.team_id;

  return (
    <ExceptionQueueTable
      title="Escalations"
      subtitle="Exceptions handed to another team to resolve"
      blurb="Open a row to review the note and history in Ace."
      // Team-scoped users (Wayne/Cary operators) only see escalations to their
      // own team; platform/org-level users (no team_id) see all of them —
      // same scoping rule pageVisible() uses in utils/rbac.ts.
      predicate={r =>
        !!r.escalated_to_team &&
        (!effectiveTeam || r.escalated_to_team === effectiveTeam) &&
        EXCEPTION_STATUSES.includes(r.material_status)
      }
      stageKey="escalations"
    />
  );
}
